"use client";
import { useState, useEffect, useRef } from "react";
import styles from "./index.module.css";
import { scrollTopIcon, cartIcon } from "../../../../assets";

const FloatingHelper = ({
  modal,
  showCart,
  cart = {},
  setIsShowingFloater,
}) => {
  function calculateTotalItems(cart) {
    cart = cart || {};
    let { paymentItem } = cart;
    paymentItem = paymentItem || [];
    return paymentItem.reduce((total, item) => total + item.unit, 0);
  }

  const cartCount = calculateTotalItems(cart);

  const [scrolled, setScrolled] = useState(false);
  const [showScrollTop, setShowScrollTop] = useState(false);

  const lastScrollYRef = useRef(0);
  const triggerPointRef = useRef(0);

  const handleScrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  useEffect(() => {
    setIsShowingFloater?.(scrolled && !modal); // tell parent if floater is showing
  }, [scrolled, modal]);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollY = window.scrollY;
      const delta = currentScrollY - lastScrollYRef.current;

      // Show floating cart after 100px
      setScrolled(currentScrollY > 100);

      if (currentScrollY <= 50) {
        // near top
        setShowScrollTop(false);
        triggerPointRef.current = currentScrollY;
      } else if (delta > 0) {
        // scrolling down
        triggerPointRef.current = currentScrollY;
        setShowScrollTop(false);
      } else if (delta < 0 && currentScrollY > 300) {
        // scrolling up beyond 300px
        if (triggerPointRef.current - currentScrollY >= 100) {
          setShowScrollTop(true);
        }
      }

      lastScrollYRef.current = currentScrollY;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      {/* {scrolled && !modal && (
        <div className={styles.floatingCart} onClick={showCart}>
          {cartIcon}
          {cart?.paymentItem && cartCount > 0 && (
            <span className={styles.floatingCartCount}>{cartCount}</span>
          )}
        </div>
      )} */}

      {showScrollTop && !modal && (
        <div className={styles.scrollTopButton} onClick={handleScrollToTop}>
          {scrollTopIcon}
        </div>
      )}
    </>
  );
};

export default FloatingHelper;
